import DesignTokens from '@tableau/design-tokens';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

const IP_ALLOWLIST_SETTINGS__PREFIX = 'ip-allowlist-settings';

export const ipAllowlistContainer = cssClass(IP_ALLOWLIST_SETTINGS__PREFIX, 'containter', {
    display: 'block',
    paddingBottom: CommonStyles.Sizes.LargeSpace,
    width: 508
});

export const ipAllowlistContainerInner = cssClass(IP_ALLOWLIST_SETTINGS__PREFIX, 'inner', {
    marginLeft: '25px'
});

export const ipAllowlistDescription = cssClass(IP_ALLOWLIST_SETTINGS__PREFIX, 'description', {
    marginBottom: CommonStyles.Sizes.MediumSpace
});

export const ipAllowlistLog = cssClass(IP_ALLOWLIST_SETTINGS__PREFIX, 'log', {
    float: 'right',
});

export const ipAllowlistIpTextField = cssClass(IP_ALLOWLIST_SETTINGS__PREFIX, 'ip-text-field', {
    $nest: {
        'input::placeholder': {
          color: applyColor(DesignTokens.color.font.default.disabled, CommonStyles.Colors.Grey203) + ' !important',
        },

        'input': {
            borderColor: applyColor(DesignTokens.color.elevation.border.default.default, CommonStyles.Colors.Grey203) + ' !important',
        },

        'input[aria-invalid="true"]': {
            borderColor: applyColor(DesignTokens.color.feedback.default.error, '#ba0517')+' !important',
        }
    },
});

export const ipAllowlistIpTextFieldNewlyAdded = cssClass(IP_ALLOWLIST_SETTINGS__PREFIX, 'ip-text-field-newly-added', {
    $nest: {
        'input::placeholder': {
          color: applyColor(DesignTokens.color.font.default.disabled, CommonStyles.Colors.Grey203) + ' !important',
        },

        'input': {
            borderColor: applyColor(DesignTokens.color.icon.default.discrete, CommonStyles.Colors.DiscreteBlue) + ' !important',
        },

        'input[aria-invalid="true"]': {
            borderColor: applyColor(DesignTokens.color.feedback.default.error, '#ba0517')+' !important',
        }
    },
});